export const SALES_QUOTE_DOCUMENT_DROP_DOWN_ITEMS = [
    {
        id: "sales-quotes",
        text: "Sales Quote"
    },
   
]